import mBaseModel from "@/models/mBaseModel";
import UtilsData  from "@/utilities/UtilsData";

export default class mReportParameter extends mBaseModel {
  constructor(rawModelFields = {}) {
    super(rawModelFields);
    this.ats.Id       = 0;
    this.ats.Name     = null;
    this.ats.Order    = null;
    this.ats.ReportId = null;
    this.ats.DbName   = null;
    this.ats.Type     = 'int';
    this.ats.SubType  = null;
    this.ats.Value    = null;
    this.setRawFields(rawModelFields);
  }

  // ##################################################
  // region Data Sources
  static vocTypeSubType() {
    const voc = {
      int:    [],
      date:   [],
      select: [
        'calculations',
        'deals'
      ]
    };
    return voc;
  }

  // endregion Data Sources
  // ##################################################
  validate() {
    this._localValidationStatus  = true;
    this._localValidationResults = [];
    const modelName              = `Parameter [Order ${this.ats.Order}]`;
    const id                     = this.ats.Id;
    // #####
    if (UtilsData.isEmpty(this.ats.Name)) this._localValidationResults.push({field: 'Name', msg: 'Field is required', modelName: modelName, id: id});
    if (UtilsData.isNull(this.ats.DbName)) this._localValidationResults.push({field: 'DbName', msg: 'Field is required', modelName: modelName, id: id});
    if (UtilsData.isNull(this.ats.Type)) this._localValidationResults.push({field: 'Type', msg: 'Field is required', modelName: modelName, id: id});
    // #####
    this._localValidationStatus = this._localValidationResults.length === 0;
    return this._localValidationResults;
  }

  // ##################################################
}
